angular.module('aq.accounts.calendars').controller('CalendarWidgetCtrl', ['$scope', '$state', '$stateParams', 'CalendarData', 'EventGenerator', 'UserService',
    function($scope, $state, $stateParams, CalendarData, EventGenerator) {



}]);